module.exports = __webpack_public_path__ + "static/media/figtree-latin-ext-600.c4792ea2.woff2";